import { render, staticRenderFns } from "./CreatePlusCategory.vue?vue&type=template&id=72ba6418&scoped=true&"
import script from "./CreatePlusCategory.vue?vue&type=script&lang=js&"
export * from "./CreatePlusCategory.vue?vue&type=script&lang=js&"
import style0 from "./CreatePlusCategory.vue?vue&type=style&index=0&id=72ba6418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ba6418",
  null
  
)

export default component.exports